var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notifications-container"},[_c('div',{staticClass:"card mb-0"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('notification-component',{attrs:{"isDropdown":false}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card-header"},[_c('h3',[_vm._v("Notifications")])])
}]

export { render, staticRenderFns }